module.exports = __webpack_public_path__ + "static/media/lato-regular.41e8a4c8.woff2";